module.exports = __webpack_public_path__ + "static/0002-e8f509041063b6ce6cefdbc0ed565881.png";